import React, { useState, useEffect } from 'react';
import { BQLink } from '../../../atoms/bqlink';
import Icon from '@mdi/react';
import { connect, useSelector } from 'react-redux';
import get from 'lodash/get';
import {
  mdiAccount,
  mdiHelpCircleOutline,
  mdiChevronRight,
  mdiBinoculars,
  mdiPower,
} from '@mdi/js';
import MorningIcon from '../../../atoms/icons/good-morning-evening';
import AfternoonIcon from '../../../atoms/icons/good-afternoon';
import NightIcon from '../../../atoms/icons/good-night';
import { PATH } from '../../../../constants';
import { getSSOLoginUrl, getSSORedirectUrl } from '../../../../helpers/subscription-helper';
import { accountInteraction, signInClick } from '../../../../helpers/datalayer-utils';
import { getGreetingTime, getTodayDate, getUserInitials } from '../../../../helpers/utils';

import './user-profile.m.css';

const UserProfile = ({
  pageType,
  userData,
  isSubscriber,
  isLoggedIn,
  userProfile,
  isScrolled = false,
  logout,
}) => {
  const [member, setMember] = useState(false);
  const [loginUrl, setLoginUrl] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );
  const integrations = useSelector((state) => get(state, ['qt', 'config', 'integrations'], {}));
  const formattedTime = getTodayDate(`h:mm aa 'IST'`);
  const greeting = getGreetingTime();

  useEffect(() => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });
  }, []);
  useEffect(() => {
    getSSOLoginUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      redirectUrl,
      SSO_LOGIN_URL,
    ).then((pageUrl) => {
      setLoginUrl(pageUrl);
    });
  }, [redirectUrl]);

  useEffect(() => {
    if (userProfile) {
      const member = {
        firstName: userProfile?.fullName?.split(' ')[0],
        lastName: userProfile?.fullName?.split(' ')[userProfile.fullName.split(' ').length - 1],
      };
      setMember(member);
    }
  }, [userProfile]);

  const menuItems = [
    {
      id: 'my-watchlist',
      show: () => true,
      href: `${PATH.MYBQ_PAGE}${PATH.MYACCOUNT_WATCHLIST}?src=watchlist`,
      onClick: () => {
        accountInteraction(userData, pageType, 'header', 'watchlist');
      },
      icon: <Icon path={mdiBinoculars} size="18px" color="var(--submarine)" />,
      label: 'Watchlist',
    },
    {
      id: 'support',
      show: () => true,
      href: 'mailto:profitsupport@ndtv.com',
      icon: <Icon path={mdiHelpCircleOutline} size="18px" color="var(--submarine)" />,
      label: 'Need Help ?',
      target: '_blank',
      rel: 'noopener noreferrer',
      variant: 'transparent',
    },
  ];

  return (
    <div styleName={`profileMenu ${isScrolled ? 'scrollWrap' : ''}`}>
      <div styleName="greetingWrapper">
        <div styleName="greeting">
          {greeting === 'Morning' && <MorningIcon color="#5d6e77" />}
          {greeting === 'Afternoon' && <AfternoonIcon color="#5d6e77" />}
          {greeting === 'Evening' && <MorningIcon color="#5d6e77" />}
          {greeting === 'Night' && <NightIcon color="#5d6e77" />}
          <b styleName="text">&nbsp;Good {greeting}&nbsp;</b>
          <div styleName="time">{formattedTime}</div>
        </div>
      </div>

      <div styleName="userGreetSection">
        <div styleName={`greetingCard ${!isLoggedIn ? 'pb-10' : ''}`}>
          <div styleName={`userInitials ${isSubscriber ? 'premiumUser' : ''}`}>
            <div styleName="whiteBg">
              <div styleName="blackBg">
                <div
                  styleName={
                    getUserInitials(userProfile) ? 'innerCircle premiumCircle' : 'innerCircle'
                  }
                >
                  {getUserInitials(userProfile) ? (
                    <span styleName="initials">{getUserInitials(userProfile)}</span>
                  ) : (
                    <Icon path={mdiAccount} size="40px" color="var(--mine-shaft)" />
                  )}
                  {!!userProfile && !!userProfile.userId && (
                    <div styleName={`subTag ${isSubscriber ? 'premiumTag' : 'basicTag'}`}>
                      {isSubscriber ? <span>✦ MEMBER</span> : <span>BASIC</span>}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div styleName="nameCtx">
            {!!userProfile && !!userProfile.userId ? (
              <div onClick={() => accountInteraction(userData, pageType, 'header', 'view profile')}>
                <BQLink styleName="name" href="/my-account/profile?src=menu_user">
                  {userProfile?.fullName || getUserInitials(userProfile) || 'Hello Reader'}
                </BQLink>
              </div>
            ) : (
              <div
                styleName="name"
                onClick={() => signInClick(userData, pageType, 'Sign In / Register', 'header')}
              >
                <BQLink href={loginUrl} target="_self">
                  Sign In / Register
                </BQLink>
              </div>
            )}
            <div
              onClick={() =>
                !!userProfile && !!userProfile.userId
                  ? accountInteraction(userData, pageType, 'header', 'view profile')
                  : signInClick(userData, pageType, 'Sign In / Register', 'header')
              }
            >
              <BQLink
                href={
                  !!userProfile && !!userProfile.userId
                    ? '/my-account/profile?src=menu_user'
                    : loginUrl
                }
                styleName={isSubscriber ? 'profile premium' : 'profile'}
              >
                {!!userProfile && !!userProfile.userId ? 'View Profile' : 'Get Started'}&nbsp;
                <Icon
                  path={mdiChevronRight}
                  size="16px"
                  color={isSubscriber ? 'var(--dark-orange)' : '#d41f54'}
                />
              </BQLink>
            </div>
          </div>
        </div>
      </div>

      {isLoggedIn && (
        <ul styleName="list">
          {menuItems
            .filter((item) => item.show(isSubscriber))
            .map((item) => (
              <li key={item.id} onClick={item.onClick}>
                <BQLink
                  id={item.id}
                  href={item.href}
                  styleName="menuLink"
                  target={item.target}
                  rel={item.rel}
                  variant={item.variant}
                >
                  {item.icon}
                  {item.label}
                </BQLink>
              </li>
            ))}
        </ul>
      )}
      {member && (
        <div onClick={() => accountInteraction(userData, pageType, 'header', 'logout')}>
          <div onClick={logout} styleName="logoutLink">
            <Icon path={mdiPower} size="18px" color="var(--submarine)" /> Logout
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: get(state, ['userData', 'userProfile'], {}),
  isSubscriber: get(state, ['userData', 'isSubscriber'], false),
  isLoggedIn: get(state, ['userData', 'isLoggedIn'], false),
});

export default connect(mapStateToProps, {})(UserProfile);
